export const MIN_MAP_ZOOM = 1;
export const MAX_MAP_ZOOM = 3;
export const MAP_ZOOM_INCREMENT = 0.5;
